import * as PopoverPrimitive from '@radix-ui/react-popover'
import * as React from 'react'

import { cn } from '@/lib/utils'

const Popover = PopoverPrimitive.Root
// Use Anchor when the popover position should follow an element that opens itself.
// Unlike Trigger, Anchor does not add button-like keyboard activation behavior.
const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverTrigger = PopoverPrimitive.Trigger

const animationClasses = cn(
  'data-[state=open]:animate-in data-[state=closed]:animate-out',
  'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
  'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
)

const slideClasses = cn(
  'data-[side=bottom]:slide-in-from-top-2',
  'data-[side=left]:slide-in-from-end-2',
  'data-[side=right]:slide-in-from-start-2',
  'data-[side=top]:slide-in-from-bottom-2',
)

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        animationClasses,
        slideClasses,
        'z-50 w-72 rounded border border-gray-4 bg-popover p-4 text-popover-foreground shadow-md outline-none',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
))
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger }
